import axios from 'axios'
import { URL } from '../../../util/ambienteActions';
import { SLOW_REQUEST_CONFIG } from '../../../util/loadingUtil'

const buscarComprovantesPagamento = (idEmpresa, idFechamento) => 
    axios.get(`${URL}/fechamento-caixa-usuario/empresa/${idEmpresa}/fechamento/${idFechamento}/comprovantes`, SLOW_REQUEST_CONFIG)

export default buscarComprovantesPagamento

